/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EquipmentGeometryGeometriesInnerOneOf2
 */
export interface EquipmentGeometryGeometriesInnerOneOf2 {
    /**
     * 
     * @type {EquipmentGeometryGeometriesInnerOneOf2TypeEnum}
     * @memberof EquipmentGeometryGeometriesInnerOneOf2
     */
    type: EquipmentGeometryGeometriesInnerOneOf2TypeEnum;
    /**
     * 
     * @type {Array<Array<Array<number>>>}
     * @memberof EquipmentGeometryGeometriesInnerOneOf2
     */
    coordinates: Array<Array<Array<number>>>;
}


/**
 * @export
 */
export const EquipmentGeometryGeometriesInnerOneOf2TypeEnum = {
    Polygon: 'Polygon'
} as const;
export type EquipmentGeometryGeometriesInnerOneOf2TypeEnum = typeof EquipmentGeometryGeometriesInnerOneOf2TypeEnum[keyof typeof EquipmentGeometryGeometriesInnerOneOf2TypeEnum];


/**
 * Check if a given object implements the EquipmentGeometryGeometriesInnerOneOf2 interface.
 */
export function instanceOfEquipmentGeometryGeometriesInnerOneOf2(value: object): value is EquipmentGeometryGeometriesInnerOneOf2 {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (value['type'] !== 'Polygon') return false;
    
    if (!('coordinates' in value) || value['coordinates'] === undefined) return false;
    return true;
}

export function EquipmentGeometryGeometriesInnerOneOf2FromJSON(json: any): EquipmentGeometryGeometriesInnerOneOf2 {
    return EquipmentGeometryGeometriesInnerOneOf2FromJSONTyped(json, false);
}

export function EquipmentGeometryGeometriesInnerOneOf2FromJSONTyped(json: any, ignoreDiscriminator: boolean): EquipmentGeometryGeometriesInnerOneOf2 {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'coordinates': json['coordinates'],
    };
}

export function EquipmentGeometryGeometriesInnerOneOf2ToJSON(json: any): EquipmentGeometryGeometriesInnerOneOf2 {
    return EquipmentGeometryGeometriesInnerOneOf2ToJSONTyped(json, false);
}

export function EquipmentGeometryGeometriesInnerOneOf2ToJSONTyped(value?: EquipmentGeometryGeometriesInnerOneOf2 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'coordinates': value['coordinates'],
    };
}

